/**
 * @generated SignedSource<<84fb53b6d98189b320531115364d143c>>
 * @relayHash 4c198432b204cbcb18fb5160733adf98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cd62fad16e429cace180371436855ef292c31e1ca910185b179fd16e1c7852d4

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceSpaceRoleMode = "PRE_ROLES" | "ROLES" | "ROLES_TRANSITION" | "%future added value";
export type preloadSpaceRoleModeQuery$variables = {
  cloudId: string;
};
export type preloadSpaceRoleModeQuery$data = {
  readonly confluence_spaceRoleMode: ConfluenceSpaceRoleMode | null | undefined;
};
export type preloadSpaceRoleModeQuery = {
  response: preloadSpaceRoleModeQuery$data;
  variables: preloadSpaceRoleModeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "kind": "ScalarField",
    "name": "confluence_spaceRoleMode"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadSpaceRoleModeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadSpaceRoleModeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4c198432b204cbcb18fb5160733adf98",
    "id": "cd62fad16e429cace180371436855ef292c31e1ca910185b179fd16e1c7852d4",
    "metadata": {},
    "name": "preloadSpaceRoleModeQuery",
    "operationKind": "query",
    "text": "query preloadSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
  }
};
})();

(node as any).hash = "1b6118c2bdcdd04e86f799370c9c7bca";

export default node;
